import React from 'react';
import { Route } from 'react-router-dom';

import CategoryStats from 'features/stats/pages/CategoryStats';
import ClientsByConsultant from 'features/stats/pages/ClientsByConsultant';
import ClientsByStore from 'features/stats/pages/ClientsByStore';
import ConsultantStats from 'features/stats/pages/ConsultantStats';
import FinanceStats from 'features/stats/pages/FinanceStats';
import ProductStats from 'features/stats/pages/ProductStats';
import Snaps from 'features/stats/pages/Snaps';
import StoreStats from 'features/stats/pages/StoreStats';
import Test from 'features/stats/pages/Test';
import YearlyStats from 'features/stats/pages/YearlyStats';

export const statsRoutes = (
  <Route path='stats'>
    <Route path='stores' element={<StoreStats />} />
    <Route path='categories' element={<CategoryStats />} />
    <Route path='products' element={<ProductStats />} />
    <Route path='clients-by-store' element={<ClientsByStore />} />
    <Route path='clients-by-consultant' element={<ClientsByConsultant />} />
    <Route path='consultants' element={<ConsultantStats />} />
    <Route path='finance' element={<FinanceStats />} />
    <Route path='yearly' element={<YearlyStats />} />
    <Route path='test' element={<Test />} />
    <Route path='snaps' element={<Snaps />} />
  </Route>
);

export const statsTitles = [
  { path: '/stats/stores', title: 'Статистика магазинов' },
  { path: '/stats/categories', title: 'Статистика категорий' },
  { path: '/stats/products', title: 'Статистика товаров' },
  { path: '/stats/clients-by-store', title: 'Клиенты по магазинам' },
  { path: '/stats/consultants', title: 'Статистика консультантов' },
  { path: '/stats/finance', title: 'Финансовая статистика' },
  { path: '/stats/yearly', title: 'Годовая статистика' },
  { path: '/stats/test', title: 'Тестовая статистика' },
  { path: '/stats/snaps', title: 'Снапы' },
];
